import styled from 'styled-components'

import { ProfileRole } from '../../types'

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 64px 21px 31px;
  background-color: #fdfdfd;
  align-items: center;
  margin-bottom: 7px;
  border-radius: 10px;

  @media screen and (max-width: 700px) {
    padding: 19px 24px;
  }
`

export const HeaderRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;

  @media screen and (max-width: 700px) {
    flex-direction: column;
  }
`

export const HeaderTitle = styled.div<{
  $userRole: ProfileRole | null
}>`
  width: ${(props) =>
    props.$userRole === 'student'
      ? 'calc(100% - 427px)'
      : 'calc(100% - 128px)'};

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: wrap;

  p {
    color: #141522;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.72px;
    text-align: left;
    line-height: 36px;
  }

  .student-subheader {
    margin-top: 4px;
    color: #8e92bc;
  }

  @media screen and (max-width: 700px) {
    width: 100%;
  }
`

export const HeaderNotificationsContainer = styled.div<{
  $userRole: ProfileRole | null
}>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: ${(props) => (props.$userRole === 'student' ? '427px' : '128px')};
  align-items: center;
  gap: 24px;

  @media screen and (max-width: 700px) {
    width: 105px;
    gap: 16px;
    align-self: flex-end;
  }
`

export const ProfileContainer = styled.div`
  /* display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: absolute;
  right: 64px;
  top: 120px;
  border-radius: 10px;
  border: 1px solid #dbdbdb;
  background: #f6f6f6;
  padding: 10px 8px 17px 8px;
  color: #0a0a18;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.12px;

  .list {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;

    div {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    svg {
      font-size: 24px;
      margin-right: 8px;
    } */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: absolute;
  right: 64px;
  top: 120px;
  border-radius: 8px;
  border: 1px solid #dbdbdb;
  background: #f6f6f6;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 12px;
  color: #0a0a18;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  z-index: 1000;

  /* Flecha del tooltip */
  &::after {
    content: '';
    position: absolute;
    top: -8px;
    right: 44px;
    width: 16px;
    height: 16px;
    background: #f6f6f6;
    transform: rotate(45deg);
    border-left: 1px solid #dbdbdb;
    border-top: 1px solid #dbdbdb;
    box-shadow: none;
  }

  /* Contenedor interno para evitar que la flecha se vea por encima del contenido */
  .list {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;
    width: 100%;

    div {
      display: flex;
      align-items: center;
      cursor: pointer;
      width: 100%;
      padding: 8px;
      border-radius: 4px;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }
    }

    svg {
      font-size: 20px;
      margin-right: 8px;
      color: #8e92bc;
    }
  }

  @media screen and (max-width: 700px) {
    top: 80px;
    right: 6px;
  }
`
export const HeaderProfile = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 100px;
  overflow: hidden;
  background-position: center;
  background-size: cover;
  cursor: pointer;
  z-index: 90;

  @media screen and (max-width: 700px) {
    width: 46px;
    height: 46px;
  }
`

export const StudentHeaderContainer = styled.div<{
  $userRole: ProfileRole | null
}>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 18px;
  width: 100%;

  .bublee {
    padding: 4px 8px;
    border-radius: 10px;
    background-color: ${(props) =>
      props.$userRole === 'student' ? '#FFDC50' : '#bdddeb'};
  }

  p {
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.24px;
    color: #313131;

    span {
      color: #8e92bc;
    }
  }
`
